import styled from "styled-components";

var Card = styled.div.withConfig({
  displayName: "Card",
  componentId: "sc-1n317t-0"
})(["margin:0 auto;padding:1.5rem 1.5rem;background:", ";border:2px solid #e7e7e7;border-radius:0.75rem;&:not(:first-of-type){margin-top:1rem;}"], function (_ref) {
  var background = _ref.background,
      theme = _ref.theme;
  return background ? theme[background] : "white";
});

export default Card;